export default __webpack_public_path__ + "static/media/upArrow.aa870a80.svg";